import type { ButtonTokens } from './types';

export const button: ButtonTokens = {
  colors: {
    primary: null,
    positive: null,
    critical: null,
    warning: null,
    deal: null,
    highlight: {
      color: null,
      bgColor: null,
      active: null,
      hover: null,
      disabled: {
        bgColor: 'primary.50',
        color: 'neutral.0',
      },
      inverted: null,
    },
    secondary: {
      color: 'primary.50',
      bgColor: null,
      hover: {
        bgColor: 'neutral.0',
      },
      active: null,
      disabled: {
        bgColor: 'primary.50',
        color: 'neutral.70',
      },
      inverted: null,
    },
    text: {
      color: 'primary.50',
      bgColor: null,
      disabled: {
        color: 'primary.50',
      },
      hover: {
        color: 'primary.70',
        bgColor: 'primary.30',
      },
      active: null,
      inverted: null,
    },
  },
  space: {
    small: null,
    medium: {
      px: 'base',
      py: 'small',
    },
    large: {
      px: 'big',
      py: 'small',
    },
  },
  radii: 'small',
  opacity: '.4',
};
